export default "__VITE_ASSET__WzM_2Mye__"